import React from 'react';
import { Link } from 'gatsby';
import { Button, Icon } from 'library';

import IconList from '../../common/IconList/IconList';

import './PerksList.scss';

const PERKS = [
  {
    icon: 'equity',
    title: 'Competitive Compensation',
    text:
      'In additional to base salary, we provide the opportunity to contribute to a company-sponsored 401k plan, as well as commuter benefits.',
  },
  {
    icon: 'healthcare',
    title: 'Healthcare Coverage',
    text:
      'We offer and cover the cost of a healthy amount of comprehensive health and dental plans to take care of yourself and your family.',
  },
  {
    icon: 'work-life',
    title: 'Work-Life Balance',
    text:
      'It is important for us to support you in your life outside of work. We offer a flexible work schedule, paid parental leave, and unlimited PTO with advanced approval.',
  },
  {
    icon: 'learning',
    title: 'Learning & Development',
    text: 'We support the ongoing growth of our team members through professional development opportunities.',
  },
  {
    icon: 'compensation',
    title: 'Generous Share Package',
    text: 'We invite our employees to participate in ownership and achievement in our company.',
  },
  {
    icon: 'culture',
    title: 'Company Culture',
    text: (
      <span>
        Strong teams are built on strong bonds. Our team reguarly participates in sponsored lunches, happy hours, and
        <Link to="/homeowner-resources/volunteer-work-with-heading-home/">
          {' '}
          <Button theme="link">volunteer opportunities</Button>
        </Link>
        . Free snacks are provided (we have a generous budget for chocolate-covered almonds.)
      </span>
    ),
  },
];

const PerksList = () => {
  return (
    <div className="PerksList">
      <h2>A few great perks...</h2>
      <IconList items={PERKS} />

      <Button theme="text" href="#job-postings" className="PerksListApply">
        Ready to Apply{'  '}
        <Icon name="arrow-right" />
      </Button>
    </div>
  );
};

export default PerksList;
